import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('token')) { 
      return true;
    } else {
      this.router.navigate(['users/login'], { queryParams: { returnUrl: state.url }}, );
      return false;
      // return true;
    }

  }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService  {

  constructor(private router: Router) { }

  canActivate() {
    if (!localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class NotAuthGuardService  {

  constructor(private router: Router) { }
 
  canActivate() {
    if (!localStorage.getItem('token')) {
      return true;
    } else {
      this.router.navigate(['users/dashboard']);
      return false;
    }
  }
}
